module.exports = __webpack_public_path__ + "static/media/loading.b984a025.gif";